// extracted by mini-css-extract-plugin
module.exports = {"top-menu":"FormTopMenu_top-menu__1eofZ","active":"FormTopMenu_active__3XA2h","separator":"FormTopMenu_separator__3xRKZ","bg":"FormTopMenu_bg__cmNAK"};